import { Component, h, Prop, ComponentInterface, Host } from "@stencil/core";

/**
 * @slot (default) - Default content shown as label.
 * @slot icon - A custom icon.
 */
@Component({
    tag: "uic-breadcrumb-item",
    styleUrl: "breadcrumb-item.scss",
})
export class BreadcrumbItem implements ComponentInterface {
    /**
     * If set to `true`, the breadcrum item is visually highlighted.
     */
    @Prop() selected: boolean = false;

    /**
     * The name of the icon to show next to the label.
     */
    @Prop() icon: string;

    /**
     * The label. Use the slot for custom content.
     */
    @Prop() label: string;

    /**
     * If set to `true`, hides the label and shows three dots ("...") instead.
     */
    @Prop() ellipsis: boolean = false;

    render() {
        return (
            <Host
                class={{
                    "uic-breadcrumb-item": true,
                    "uic-breadcrumb-item--selected": this.selected,
                    "uic-breadcrumb-item--ellipsis": this.ellipsis,
                }}
            >
                <uic-icon name="uic:chevron-left"></uic-icon>
                {this.icon && (
                    <uic-icon
                        class="uic-breadcrumb-item__icon"
                        name={this.icon}
                    ></uic-icon>
                )}
                <span class="uic-breadcrumb-item__dots">...</span>
                <span class="uic-breadcrumb-item__label">
                    <slot>{this.label}</slot>
                </span>
            </Host>
        );
    }
}
